export type ProductFeature = {
  id: string;
  icon: 'wifi' | 'battery' | 'palette' | 'ruler' | 'magnet' | 'sparkles';
  title: string;
  body: string;
  metric: { value: number; decimals?: number; unit: string; label: string };
};

export const productFeatures: ProductFeature[] = [
  {
    id: 'wireless',
    icon: 'wifi',
    title: 'Wireless operation',
    body: 'No power cable to the pool. Nothing to trench, route or hide.',
    metric: { value: 0, unit: 'wires', label: 'to the pool' },
  },
  {
    id: 'battery',
    icon: 'battery',
    title: 'Rechargeable',
    body: '3000 mAh internal battery, charged by USB-C.',
    metric: { value: 3000, unit: 'mAh', label: 'rechargeable battery' },
  },
  {
    id: 'rgb',
    icon: 'palette',
    title: 'RGB lighting',
    body: '16 color options — electric blue by default.',
    metric: { value: 16, unit: 'colors', label: 'RGB + dynamic modes' },
  },
  {
    id: 'compact',
    icon: 'ruler',
    title: 'Compact',
    body: '3.3 in diameter, 1.2 in thick. Palm-sized.',
    metric: { value: 1.2, decimals: 1, unit: 'in', label: 'slim profile' },
  },
  {
    id: 'magnetic',
    icon: 'magnet',
    title: 'Magnetic mounting',
    body: 'Seats onto the matched-diameter Magnetic Mount System base. No wires. No drilling.',
    metric: { value: 3.3, decimals: 1, unit: 'in', label: 'matched-diameter base' },
  },
  {
    id: 'leds',
    icon: 'sparkles',
    title: '13-LED array',
    body: 'Thirteen 5050 LEDs in a professional-grade light engine.',
    metric: { value: 13, unit: 'LEDs', label: 'per light' },
  },
];
